import React from 'react';
import { getBEMClasses } from '../helpers/cssClassesHelper';

import withAuthentication from 'apex-web/lib/hocs/withAuthentication';
import {
  BuySellContainer,
  BuySellMakeTransactionContainer,
  BuySellBalancesContainer,
  BuySellOrderOverviewContainer
} from 'apex-web/lib/components/Retail/RetailBuySell';
import 'apex-web/lib/layouts/Responsive/EotcBuySellLayout/EotcBuySellDesktopLayout.css';

import PageFooterLayout from 'apex-web/lib/components/PageFooter/PageFooterComponent';

import './BuySellPage.css';

const classes = getBEMClasses('eotc-buy-sell-layout');

const BuySellPage = () => (
  <React.Fragment>
    <div className={classes('accent-bar')} />
    <div className={classes('container')}>
      <div className={classes('col', ['lg'])}>
        <div
          className={classes(
            'make-transaction-container container-with-shadow'
          )}>
          <div className={classes('make-transaction-col-1 ')}>
            <BuySellMakeTransactionContainer>
              <BuySellContainer />
            </BuySellMakeTransactionContainer>
          </div>

          <div className={classes('make-transaction-col-2')}>
            <div className={classes('order-overview-container')}>
              <BuySellOrderOverviewContainer displayPricePerUnit />
            </div>

            <hr className={classes('right-panel-divider')} />

            <div className={classes('balances-container ')}>
              <BuySellBalancesContainer />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={classes('footer')}>
      <PageFooterLayout />
    </div>
  </React.Fragment>
);

export default withAuthentication(BuySellPage);



// WEBPACK FOOTER //
// ./src/pages/BuySellPage.js